import {Typography } from "@mui/material";
import logo from "~assets/checkMessage.svg";
import { getStyles } from "./styles";


interface RepliedMessageProps {
    onTime: string;
  }

const RepliedMessage: React.FC<RepliedMessageProps> = ({ onTime }) => {
    const { styles } = getStyles();
    
    return(
        <div style={styles.container}>
         <Typography style={styles.message}>mensagem respondida em {onTime}</Typography>
         <img alt="logo" src={logo} />
        </div>
    )
}

export default RepliedMessage;